<div class="bg-white tw-p-1 rounded-2 tw-pt-5 cancel-request-token">
  <!--content-->
  <h2 class="tw-text-xl border-bottom tw-pb-5">
    <div
      class="tw-px-5 tw-py-3 tw-text-center"
      [innerHTML]="'messages.cancelRequest' | translate"
    ></div>
  </h2>

  <!-- actions -->
  <div class="buttons tw-flex tw-w-[350px] tw-justify-around">
    <button
      mat-ripple
      class="btn btn-success tw-text-lg tw-font-bold"
      (click)="close()"
    >
      <span>
        {{ "common.stayRequest" | translate }}
      </span>
    </button>

    <button
      mat-ripple
      class="btn tw-text-lg tw-font-bold tw-flex-center btn-danger"
      (click)="confirm()"
    >
      <span>
        {{ "common.cancellationRequest" | translate }}
      </span>
    </button>
  </div>
</div>
